export default __webpack_public_path__ + "static/media/credit_cardpayment.f396215f.svg";